var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 1.211
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.011 263.412L27.657 12.694h245.624L250.906 263.37l-100.587 27.886zm0 0",
    fill: "#1572b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47 269.943l81.278-22.534L250.87 33.194h-100.4zm0 0",
    fill: "#33a9dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47 124.028h40.69l2.809-31.489h-43.5V61.79h77.106l-.737 8.25-7.557 84.737h-68.812zm0 0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.654 203.886l-.135.037-34.246-9.247-2.19-24.523H83.217l4.307 48.28 62.988 17.486.142-.04zm0 0",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.546 153.474l-3.703 41.182-34.295 9.256v31.992l63.038-17.471.462-5.194 5.349-59.765zm0 0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.576 61.79v30.75H76.303l-.618-6.912-1.401-15.588-.735-8.25zm-.106 62.242v30.749h-33.812l-.617-6.91-1.402-15.59-.735-8.25zm0 0",
    fill: "#ebebeb"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.9f10584de3b476ca25d0273b92ffe4f4.svg";
export { ForwardRef as ReactComponent };